import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck } from '@fortawesome/free-solid-svg-icons';
import '../StylesComponents/trust-bar.css';

const SIGNALS = [
  'Verified Retail Partners',
  'Checkout Direct With The Official Retailer',
  'New Deals Tracked Daily',
  'Free To Browse',
  'Largest Catalogue of Discounted Brands',
];

function TrustSignal({ signal }) {
  return (
    <span className="trust-signal">
      <FontAwesomeIcon icon={faCircleCheck} className="trust-signal-icon" />
      {signal}
    </span>
  );
}

const TrustBar = () => {
  return (
    <div className="trust-bar" role="note" aria-label="Why you can trust Stockroom">
      {/* Desktop: static centered row */}
      <div className="trust-bar-track trust-bar-track--static">
        {SIGNALS.map((signal) => (
          <TrustSignal key={signal} signal={signal} />
        ))}
      </div>

      {/* Tablet / mobile: infinite stock ticker (duplicated for seamless loop) */}
      <div className="trust-bar-track trust-bar-track--ticker" aria-hidden="true">
        <div className="trust-bar-ticker-group">
          {SIGNALS.map((signal) => (
            <TrustSignal key={`a-${signal}`} signal={signal} />
          ))}
        </div>
        <div className="trust-bar-ticker-group">
          {SIGNALS.map((signal) => (
            <TrustSignal key={`b-${signal}`} signal={signal} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default TrustBar;
